import React from 'react';
import { lowerCase } from 'lodash';
import { useNavigate } from 'react-router-dom';

import { Alert, Stack } from 'react-bootstrap';

import api from 'api';
import useMountEffect from 'hooks/useMountEffect';
import useRequest from 'hooks/useRequest';
import useTableState from 'hooks/useTableState';

import Table from 'components/elements/Table';
import SiteVisitCalendar from 'components/forms/SiteVisitCalendar';
import SectionWrapper from 'components/layout/SectionWrapper';

import VerificationListMenu from './VerificationListMenu';
import { tableColumns } from './utils';

const VerificationList = () => {
  const navigate = useNavigate();
  const {
    page, handlePageChange, sortBy, sortOrder, handleSortChange,
  } = useTableState('userRole', 'asc', {});
  const {
    doRequest: getListData,
    data: listData,
    isLoading,
    error,
  } = useRequest(api.getAssignments);

  const handleDataRetreive = React.useCallback(() => {
    getListData({
      page,
      Order: sortBy,
      OrderDirection: sortOrder,
    });
  }, [getListData, page, sortBy, sortOrder]);

  useMountEffect(handleDataRetreive);

  return (
    <SectionWrapper title="Verification Dashboard">
      <Stack
        direction="horizontal"
        gap={3}
        className="align-items-start flex-wrap"
        style={{ minWidth: 0 }}
      >
        <div style={{ flex: '1 1 900px', minWidth: 0 }}>
          {error ? (
            <Alert variant="danger">Error loading list</Alert>
          ) : (
            <Table
              columns={tableColumns}
              items={listData?.items ?? []}
              minTableWidth="760px"
              order={sortBy}
              orderDirection={sortOrder}
              pagination={{
                page,
                total: listData?.total ?? 0,
                limit: listData?.limit ?? 0,
              }}
              handlePageChange={handlePageChange}
              handleOrderChange={handleSortChange}
              onClickRow={({ applicationId, roleOnVerification }) => navigate(`${lowerCase(roleOnVerification)}/${applicationId}`)}
              isLoading={isLoading}
            />
          )}
        </div>
        <Stack gap={3} style={{ flexShrink: 0, flexBasis: '280px' }}>
          <VerificationListMenu />
          <SiteVisitCalendar />
        </Stack>
      </Stack>
    </SectionWrapper>
  );
};

export default VerificationList;
